import React from 'react';
import InvoiceLayout from './components/InvoiceLayout';
import {EmptyState} from 'components';
import {corruptedFile} from 'assets/images/images';

function ReceivedInvoices() {
  return (
    <InvoiceLayout>
      <EmptyState
        height={35}
        body={'No received invoices'}
        src={corruptedFile}
        noBtn
      />{' '}
    </InvoiceLayout>
  );
}

export default ReceivedInvoices;
